import { h } from 'preact'
import EmptyPage from '../empty-page/EmptyPage'
import globals from '../../utils/globals'
import SimpleFilterSelector from '../overview/filters/SimpleFilterSelector'
import Overview from '../overview'
import LastActivityCell from '../overview/cells/LastActivityCell'
import UserCell from '../overview/cells/UserCell'
import UserFilterSelector from '../overview/filters/UserFilterSelector'
import DateCell from '../overview/cells/DateCell'
import TitleCell from '../overview/cells/TitleCell'

type Props = {
  moderationLabels: any[],
  moderatorTags: any[],
  ideationStatuses: any[]
}

const IdeationOverview = ({ moderationLabels, moderatorTags, ideationStatuses } : Props) => {
  function getFilters () {
    return [
      {
        id: 'ideationStatus',
        type: 'simple',
        name: 'Ideation status',
        items: ideationStatuses.map((ideationStatus: any) => ({ id: ideationStatus.id, name: ideationStatus.name, value: ideationStatus.name })),
        component: SimpleFilterSelector,
        isSearchable: true,
        isMain: true
      },
      {
        id: 'moderationLabel',
        type: 'simple',
        name: 'Moderation label',
        items: moderationLabels.map((moderationLabel: any) => ({ id: moderationLabel.id, name: moderationLabel.title, value: moderationLabel.title })),
        component: SimpleFilterSelector,
        isSearchable: true
      },
      {
        id: 'moderatorTag',
        type: 'simple',
        name: 'Moderation tag',
        items: moderatorTags.map((moderatorTag: any) => ({ id: moderatorTag.id, name: moderatorTag.text, value: moderatorTag.text })),
        component: SimpleFilterSelector,
        isSearchable: true
      },
      {
        id: 'assignedModerator',
        type: 'user',
        name: 'Assigned moderator',
        items: [],
        component: UserFilterSelector,
        fetchUrl: '/member/getModerators?query='
      }
    ]
  }
  function getColumns () {
    return [
      { header: 'Title', accessor: 'title', cell: TitleCell() },
      { header: 'Ideation Status', accessor: 'ideationStatus' },
      { header: 'Votes', accessor: 'likes' },
      { header: 'Replies', accessor: 'replyCount' },
      { header: 'Author', accessor: 'author', cell: UserCell('author') },
      { header: 'Publish Date', accessor: 'createdAt', cell: DateCell('createdAt'), sorting: 'createdAt' },
      { header: 'Last Activity', accessor: 'lastActivity', cell: LastActivityCell(), sorting: 'lastActivityAt' }
    ]
  }

  return <Overview
    type='ideation'
    withPagination={{
      page: 1,
      pageSize: 25
    }}
    withSorting={{
      lastActivityAt: 'desc',
      createdAt: 'desc'
    }}
    withFilters={getFilters()}
    withSearch
    counterLabel='Ideas'
    rowId='id'
    model={getColumns()}
    endpoint='/idea/overview/topics'
    dataKey='topics'
    EmptyStateComponent={<EmptyPage
      img_src={`${globals('defaultCdn')}/images/empty_page.png`}
      header='There are no ideas yet'
      text={'Seems like no one on your team has created an idea. \n Start now by creating a new idea.'}
      button={{ link: '/content/new/idea', text: 'New idea' }}
    />}
  />
}

export default IdeationOverview
